import styled from 'styled-components';
import { SSubCard as SGenericSubCard } from 'styles/components';
import { SColumn } from 'styles/layout';

export const SWrapper = styled(SColumn)`
    flex: auto;
    gap: 2rem;
`;

export const SButton = styled.div`
    margin: 2rem;
    align-self: start;
`;

export const SSubCard = styled(SGenericSubCard)`
    gap: 2rem;
`;
